module.exports = __webpack_public_path__ + "img/NP8.929b4365.jpeg";